import { render, staticRenderFns } from "./JgpTab.vue?vue&type=template&id=0509a170&"
import script from "./JgpTab.vue?vue&type=script&lang=js&"
export * from "./JgpTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports